import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { JsonDataService } from 'vhobjects-service/src/services';
// import { ChooseIconComponent } from '../../../../objects/basic/icon/choose-icon/choose-icon.component';
// import { EditNameComponent } from '../../../frame-banner/config/frame-banner-config/edit-name/edit-name.component';
import { VhImage, VhQueryAutoWeb, VhEventMediator } from 'vhautowebdb';
import { NzContextMenuService, NzDropdownMenuComponent } from 'ng-zorro-antd/dropdown';
import { forkJoin } from 'rxjs';
import { HttpClient } from '@angular/common/http';
// import { ChooseImageComponent } from '../../../../objects/basic/image/choose-image/choose-image.component';
// import { ManageLibraryComponent } from '../../../../manage-library/manage-library.component'
import { FunctionService} from 'vhobjects-service/src/services';
import { ChooseIconComponent, ChooseImageComponent, ManageLibraryComponent } from 'vhobjects-service';

@Component({
  selector: 'atw-frame-collapse-config',
  templateUrl: './frame-collapse-config.component.html',
  styleUrls: ['./frame-collapse-config.component.scss']
})

export class AtwFrameCollapseConfig implements OnInit {
  @Input() class: any; // là dữ liệu desktop_class hoặc mobile_class từ database
  @Input() config: any;
  @Input() staticdata: any; // là dữ liệu staticdata từ database
  @Input() device: any;
  @Input() rMessage: any = {}; // Biến dùng để nhận lựa chọn (block, frame, object) { status: 1, code: '' };
  @Input() objectChoosing: any; // lấy giá trị data trả vể từ page
  @Input() type: any = 'page';
  @Output() changeOptionConfig = new EventEmitter<any>();
  @Output() framePicking = new EventEmitter();
  @Output() deleteFrame = new EventEmitter();

  menuItemList = true;
  public isViewAll: boolean = false;
  public isCollapsed: boolean = false;
  public menus: any = {
    menu1: true,
    menu2: false,
    menu3: false,
    menu4: false,
    menu5: false,
    menu6: false,
    menu7: false,
    menu8: false,
    menu9: false,
  };
  public pages: Array<any> = []; // Danh sách trang đang có trong dự án
  fonts = [];
  public bootstrapIconArrows: any = [
    {
      expand_icon: 'bi bi-caret-left',
      collapse_icon: 'bi bi-caret-down',
    },
    {
      expand_icon: 'bi bi-caret-down',
      collapse_icon: 'bi bi-caret-left',
    },
    {
      expand_icon: 'bi bi-caret-left-fill',
      collapse_icon: 'bi bi-caret-down-fill',
    },
    {
      expand_icon: 'bi bi-caret-down-fill',
      collapse_icon: 'bi bi-caret-left-fill',
    },
    {
      expand_icon: 'bi bi-caret-down-square',
      collapse_icon: 'bi bi-caret-left-square',
    },
    {
      expand_icon: 'bi bi-caret-left-square',
      collapse_icon: 'bi bi-caret-down-square',
    },
    {
      expand_icon: 'bi bi-plus-circle',
      collapse_icon: 'bi bi-dash-circle',
    },
    {
      expand_icon: 'bi bi-chevron-down',
      collapse_icon: 'bi bi-chevron-up',
    },
  ];
  public currentViewAll: any = {};
  public stylesField = [
    {
      title: 'cau_hinh_chi_tiet_hieu_ung',
      index: 1,
    }
  ];
  /** Trạng thái hiển thị context menu ở dấu 3 chấm */
  isShowContextMenu = false;
  /** Collapse đang được chọn */
  collapseChoosing: any;

  isShowConfirmPopup: boolean = false;
  id_subproject: string;
  animation: any = {};
  effect_hover = [];
  effect_hover_data: any = {}
  customize = [];


  constructor(
    public vhQueryAutoWeb: VhQueryAutoWeb,
    private nzContextMenuService: NzContextMenuService,
    private jsonDataService: JsonDataService,
    private matDialog: MatDialog,
    private http: HttpClient,
    private vhImage: VhImage,
    public functionService: FunctionService,
    private vhEventMediator: VhEventMediator,
  ) {
  }


  ngOnInit(): void {
    this.id_subproject = this.vhQueryAutoWeb.getlocalSubProject_Working()._id;
    forkJoin([
      this.http.get('assets/fonts/fonts.json'),
      this.http.get('assets/data/effects/frame-collapse.json')
    ]).subscribe(
      ([fonts, effects]: any) => {
        this.fonts = fonts;
        this.effect_hover = effects;
        this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type'])
      }
    );

    // Gán tạm các giá trị chưa có sau khi thay đổi json
    if (!this.class['expansion-body']) {
      this.class['expansion-body'] = {
        "transition": "0.3s"
      }
    }

    if (!this.config['animation-selected']) {
      this.config['animation-selected'] = { "id": "000000" }
    }

    if (!this.class['frame-collapse']['box-shadow']) {
      this.class['frame-collapse']['box-shadow'] = 'none';
    }

    if (!this.config['box-shadow']) {
      this.config['box-shadow'] = {
        "is_box_shadow": false,
        "property_box_shadow": {
          "type": "outset",
          "h-offset": 1,
          "v-offset": 1,
          "blur": 1,
          "spread": 1,
          "color": "#ffffffff"
        }
      };
    }
  }

  ngOnChanges(): void {
    if (this.effect_hover) {
      this.effect_hover_data = this.effect_hover.find(e => e.type == this.staticdata[this.device + '_animation_type']);
      this.customize = this.effect_hover_data?.data?.find(e => e.id == this.config['animation-selected']?.id)?.customize || [];
    }
  }

  /* ------------------------ CÁC THAO TÁC VỚI COLLAPSE ----------------------- */


  /** 
   * Hàm thực hiện việc thay đổi vị trí của các collapse trong danh sách
   */
  cdkDropListDropped(event: CdkDragDrop<any[]>) {
    moveItemInArray(this.objectChoosing.objects, event.previousIndex, event.currentIndex);
    this.objectChoosing.objects.forEach((item, index) => {
      item.index = index;
      this.vhQueryAutoWeb.updateObject(item._id, { index: item.index })
    });
  }


  /**
   *  Hàm thực hiện chọn collapse phần thành phần collapse, đồng thời thiết lập cấu hình cho từng collapse
   * @param collapse
   * @param event
   */
  chooseSettingCollapse(collapse, event) {
    if (event) event.stopPropagation();
    this.collapseChoosing = collapse;
    if (!this.collapseChoosing[this.device + '_class']['expansion-title__icon']) {
      this.collapseChoosing[this.device + '_class']['expansion-title__icon'] = {
        "font-size": "20px",
        "color": "#000000",
        "display": "flex",
        "justify-content": "center",
        "align-items": "center",
      }
    }
    if (!this.collapseChoosing[this.device + '_class']['expansion-title__image']) {
      this.collapseChoosing[this.device + '_class']['expansion-title__image'] = {
        width: '32px',
        height: '32px',
      }
    }
  }


  /** 
   * Hàm thực hiện mở option lựa chọn khi chọn vào 3 chấm
   *
   * @param event
   * @param menu
   */
  onContextMenu(event: MouseEvent, menu: NzDropdownMenuComponent): void {
    this.isShowContextMenu = !this.isShowContextMenu;
    if (this.isShowContextMenu === true) {
      this.nzContextMenuService.create(event, menu);
    } else {
      this.nzContextMenuService.close();
    }
  }


  /** 
   * Hàm thêm collapse
   */
  addCollapse() {
    let maxIndex = 0;
    if (this.objectChoosing.objects.length) {
      maxIndex = Math.max(...this.objectChoosing.objects.map((item) => item.index));
    }
    this.jsonDataService.getFrame('frame_blank').subscribe((frame: any) => {
      // đoạn này giống thêm frame-blank vào objects ở design-web.service.ts
      frame = {
        id_object: this.objectChoosing._id,
        is_child_collapse: true,
        ...frame,
        name: 'Collapse ' + (maxIndex + 2),
        ['name_' + this.functionService.selectedLanguageCode]: 'Collapse ' + (maxIndex + 2),
        configCollapse: {},
        staticdata: {
          ...frame.staticdata,
          content: `Collapse ` + (maxIndex + 2),
          link: null,
          hyper_link: '',
          type_link: 'none',
          is_scroll: false,
        },
        isResize: {
          top: false,
          right: false,
          bottom: true,
          left: false,
        },
        height: 200,
        index: maxIndex + 1,
        [`desktop_position_${this.objectChoosing._id}`]: {
          ...frame.desktop_position,
        },
        [`tablet_landscape_position_${this.objectChoosing._id}`]: {
          ...frame.tablet_landscape_position,
        },
        [`tablet_portrait_position_${this.objectChoosing._id}`]: {
          ...frame.tablet_portrait_position,
        },
        [`mobile_portrait_position_${this.objectChoosing._id}`]: {
          ...frame.mobile_portrait_position,
        },
        [`mobile_landscape_position_${this.objectChoosing._id}`]: {
          ...frame.mobile_landscape_position,
        },
        desktop_config: {
          ...frame.desktop_config,
          icon_after: {
            collapse_icon: 'bi bi-caret-down',
            expand_icon: 'bi bi-caret-left',
            hide: false,
          },
          icon_before: {
            name: 'search',
            hide: false,
            type: 'icon',
            image_source: '0',
            image_url: ''
          },
          hide_body: false,
        },
        tablet_landscape_config: {
          ...frame.tablet_landscape_config,
          icon_after: {
            collapse_icon: 'bi bi-caret-down',
            expand_icon: 'bi bi-caret-left',
            hide: false,
          },
          icon_before: {
            name: 'search',
            hide: false,
            type: 'icon',
            image_source: '0',
            image_url: ''
          },
          hide_body: false
        },
        tablet_portrait_config: {
          ...frame.tablet_portrait_config,
          icon_after: {
            collapse_icon: 'bi bi-caret-down',
            expand_icon: 'bi bi-caret-left',
            hide: false,
          },
          icon_before: {
            name: 'search',
            hide: false,
            type: 'icon',
            image_source: '0',
            image_url: ''
          },
          hide_body: false
        },
        mobile_portrait_config: {
          ...frame.mobile_portrait_config,
          icon_after: {
            collapse_icon: 'bi bi-caret-down',
            expand_icon: 'bi bi-caret-left',
            hide: false,
          },
          icon_before: {
            name: 'search',
            hide: false,
            type: 'icon',
            image_source: '0',
            image_url: ''
          },
          hide_body: false
        },
        mobile_landscape_config: {
          ...frame.mobile_landscape_config,
          icon_after: {
            collapse_icon: 'bi bi-caret-down',
            expand_icon: 'bi bi-caret-left',
            hide: false,
          },
          icon_before: {
            name: 'search',
            hide: false,
            type: 'icon',
            image_source: '0',
            image_url: ''
          },
          hide_body: false
        },
        desktop_class: {
          ...frame.desktop_class,
          'frame-blank': {
            ...frame.desktop_class['frame-blank'], // giữ lại tất cả thuộc tính của frame-blank
            'background-color': '#fff',
            width: '100%',
            height: '100%',
            'min-height': '200px',
          },
          "expansion-title__icon": {
            "font-size": "20px",
            "color": "#000000",
            "display": "flex",
            "justify-content": "center",
            "align-items": "center",
          },
          "expansion-title__image": {
            width: '32px',
            height: '32px',
          }
        },
        mobile_portrait_class: {
          ...frame.mobile_portrait_class,
          'frame-blank': {
            ...frame.mobile_portrait_class['frame-blank'],
            'background-color': '#fff',
            width: '100%',
            height: '100%',
            'min-height': '200px',
          },
          "expansion-title__icon": {
            "font-size": "20px",
            "color": "#000000",
            "display": "flex",
            "justify-content": "center",
            "align-items": "center"
          },
          "expansion-title__image": {
            width: '32px',
            height: '32px',
          }
        },
        tablet_landscape_class: {
          ...frame.tablet_landscape_class,
          'frame-blank': {
            ...frame.tablet_landscape_class['frame-blank'],
            'background-color': '#fff',
            width: '100%',
            height: '100%',
            'min-height': '200px',
          },
          "expansion-title__icon": {
            "font-size": "20px",
            "color": "#000000",
            "display": "flex",
            "justify-content": "center",
            "align-items": "center",
          },
          "expansion-title__image": {
            width: '32px',
            height: '32px',
          }
        },
        tablet_portrait_class: {
          ...frame.tablet_portrait_class,
          'frame-blank': {
            ...frame.tablet_portrait_class['frame-blank'],
            'background-color': '#fff',
            width: '100%',
            height: '100%',
            'min-height': '200px',
          },
          "expansion-title__icon": {
            "font-size": "20px",
            "color": "#000000",
            "display": "flex",
            "justify-content": "center",
            "align-items": "center",
          },
          "expansion-title__image": {
            width: '32px',
            height: '32px',
          }
        },
        mobile_landscape_class: {
          ...frame.mobile_landscape_class,
          'frame-blank': {
            ...frame.mobile_landscape_class['frame-blank'],
            'background-color': '#fff',
            width: '100%',
            height: '100%',
            'min-height': '200px',
          },
          "expansion-title__icon": {
            "font-size": "20px",
            "color": "#000000",
            "display": "flex",
            "justify-content": "center",
            "align-items": "center",
          },
          "expansion-title__image": {
            width: '32px',
            height: '32px',
          }
        },
      };
      this.vhQueryAutoWeb.addObject(frame).then(
        (frameResponse: any) => {
          if (frameResponse) {
            // this.objectChoosing.objects = [...this.objectChoosing.objects, frameResponse]; // Mỗi lần addObject là nó sẽ init lại nên là đã tự thêm vào mảng rồi, không cần dòng này nữa
            // setTimeout(() => {
            //   this.updateObject();
            // }, 100);
          }
        },
        (error) => {
          console.error(error);
          alert('Đã xảy ra lỗi khi thêm frame');
        }
      );
    });
  }


  /** 
   * Hàm này thực hiện xóa collapse cho frame, với giá trị collapse đang được active. Chú ý: tìm theo label
   */
  deleteCollapse(frame: any) {
    this.vhQueryAutoWeb.deleteObject(frame._id).then((bool: any) => {
    });

    if (this.objectChoosing.objects.length == 0) {
      this.vhQueryAutoWeb.deleteObject(this.objectChoosing._id).then((bool: any) => {
      });
    }
  }

  /**
   * Tạo màu ngẫu nhiên cho frame
   * @returns
   */
  getRandomColor(): string {
    const letters: string = '0123456789ABCDEF';
    let color: string = '#';
    for (let i: number = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  }


  /* ----------------------- CÁC HÀM UPDATE LÊN DATABASE ---------------------- */


  /**
   * Hàm update class vào database.
   */
  updateClass() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_class']: this.class,
      })
      .then((bool: any) => {

      });
  }


  /**
   *Hàm update config vào database.
   */
  updateConfig() {
    this.vhQueryAutoWeb
      .updateObject(this.objectChoosing._id, {
        [this.device + '_config']: this.config,
      })
      .then((bool: any) => {

      });
  }





  /**
   * Hàm này dùng để cho phép mở menu config .
   * Khi mở ở vị trí menu[0] thì các menu khác (menu[n]) đóng lại.
   * @param: value
   */
  openHandler(value: string): void {
    for (const key in this.menus) {
      if (key !== value) {
        this.menus[key] = false;
      }
    }
  }


  /* ---- CÁC PHƯƠNG THỨC LIÊN QUAN ĐẾN UPLOAD ICON SAU ---- */


  /** 
   * Hàm này dùng để mở dialog của component icon
   */
  openDialogChooseIcon() {
    const dialogRef = this.matDialog.open(ChooseIconComponent, {
      width: '80vw',
      height: '70vh',
      disableClose: false,
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.collapseChoosing[this.device + '_config'].icon_before.name = result.icon;
        this.updateCollapseChoosingConfig();
      }
    });
  }


  /**
   * 
   * @param value Khi thay đổi Bộ icon (Thu gọn/ mở rộng nội dung)
   */
  onChangeIcons(value: { expand_icon: string, collapse_icon: string }) {
    this.collapseChoosing[this.device + '_config'].icon_after.collapse_icon = value.collapse_icon;
    this.collapseChoosing[this.device + '_config'].icon_after.expand_icon = value.expand_icon;
    this.updateCollapseChoosingConfig();
  }


  /**
   * Khi thay đổi cấu hình Giới hạn chiều cao để cuộn
   */
  updateMaxHeight() {
    if (this.config['max_height']) {
      this.class['frame-collapse']['max-height'] = '200px';
      this.class['frame-collapse']['overflow-y'] = 'auto';
    }
    else {
      this.class['frame-collapse']['max-height'] = 'none';
      this.class['frame-collapse']['overflow-y'] = 'unset';
    }
    this.updateConfig();
    this.updateClass();
  }


  /* --------------- CÁC HÀM LIÊN QUAN UPLOAD ẢNH CHO ICON TRƯỚC -------------- */


  /**
   *  Khi click Upload ảnh từ máy
   * @param e
   */
  handleUploadImg(e) {
    const file = e.target?.files[0];
    if (file) {
      this.vhImage
        .getImageFromDesktop(
          file,
          'images/design/objects',
          this.collapseChoosing[this.device + '_config']['icon_before']['image_url'] || null,
          2000000
        )
        .then(
          (rsp: any) => {
            if (rsp.vcode === 0) {
              this.collapseChoosing[this.device + '_config']['icon_before']['image_url'] = rsp.data;
              this.updateCollapseChoosingConfig();
              this.functionService.createMessage('success', 'Hình ảnh đã được tải thành công !!!');
            }
            else {
              this.functionService.createMessage('error', `Tải ảnh thất bại! Lý do: ${rsp.message}`);
            }
          },
          (error) => {
            console.log(error);
          }
        );
    }
  }


  path = '/images';
  /**
   * Hàm xử lý lấy ảnh ở thư viện
   */
  openLibrary() {
    const dialogRef = this.matDialog.open(ManageLibraryComponent, {
      width: '85%',
      maxWidth: '100%',
      data: {
        startPath: this.path ? this.path : '/images/design/objects',
        scopeData: '/images',
      },
      disableClose: true,
    });
    dialogRef.afterClosed().subscribe((data) => {
      if (data.href) {
        this.collapseChoosing[this.device + '_config']['icon_before']['image_url'] = data.href;
        this.updateCollapseChoosingConfig();
      }
      this.path = data.path;
    });
  }


  /**
   * Mở dialog chọn ảnh free
   */
  openImageFree() {
    const dialogRef = this.matDialog.open(ChooseImageComponent, {
      width: '80vw',
      height: '90vh',
      disableClose: false,
    });
    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.collapseChoosing[this.device + '_config']['icon_before']['image_url'] = result;
        this.updateCollapseChoosingConfig();
        this.isShowConfirmPopup = true;
      }
    });
  }


  /**
   * Hàm này dùng để mở rộng phần cấu hình.
   * @param field_text : trả về phần tử được chọn của mảng style_field
   */
  openViewAll(field_text) {
    this.currentViewAll = field_text;
    this.isViewAll = !this.isViewAll;
  }

  /**
   * Hàm này set customize mở phần mở rộng của config từ choose-animations-config truyền về
   * @param event customize sau khi thay đổi
   */
  openAnimationDetail(event) {
    this.customize = event;
    this.openViewAll(this.stylesField[0])
  }


  /**
   * hàm này nhận sk thay đổi width height từ component app-width-height-config truyền về
   * @param event width hieght của element sau khi thay đổi
   */
  changeWidthHeight(event) {
    if (event.width) this.class['frame-collapse']['width'] = event.width + 'px';
    if (event.height) this.class['frame-collapse']['height'] = event.height + 'px';
    this.updateClass();
    this.vhEventMediator.notifyOnConfigChanged({ status: 'update-object-selected-ruler', code: this.objectChoosing._id });
  }

  updateCollapseChoosingStaticData() {
    this.vhQueryAutoWeb.updateObject(this.collapseChoosing._id, { staticdata: this.collapseChoosing.staticdata })
  }

  updateCollapseChoosingConfig() {
    this.vhQueryAutoWeb.updateObject(this.collapseChoosing._id, { [this.device + '_config']: this.collapseChoosing[this.device + '_config'] })
  }

  updateCollapseChoosingClass() {
    this.vhQueryAutoWeb.updateObject(this.collapseChoosing._id, { [this.device + '_class']: this.collapseChoosing[this.device + '_class'] })
  }

  updateCollapseChoosingName() {
    this.vhQueryAutoWeb.updateObject(this.collapseChoosing._id, { ['name_' + this.functionService.selectedLanguageCode]: this.collapseChoosing['name_' + this.functionService.selectedLanguageCode] })
  }

}
